<div class="app-body" style="margin-top: 1%; margin-bottom: 1%;">
  <div class="container">
    <div class="row justify-content-center text-center align-items-center">
      <div class="col-sm-9">
        <img [src]="appLogo" alt="vp_logo" class="center mb-1" width="200px">
        <h2 style="font-family: Organetto;">{{appName}}</h2>
        <hr class="my-2">
        <div class="clearfix">
          <h1 class="float-left display-2 mr-4 text-danger"><i class="fa fa-exclamation-triangle"
              aria-hidden="true"></i>
          </h1>
          <h1 class="pt-3">Error!</h1>
          <h3 [innerHTML]="message"></h3>
          <hr>
          <h4 class="text-muted">Go back to <a class="text-primary" (click)="goToLogin()">login</a> page.</h4>
        </div>
      </div>
    </div>
  </div>
</div>